<template>
  <el-dialog
    :title="type === 'edit'?'编辑':'新增'"
    :visible.sync="dialog"
    :width="getIsMobile?'100%':'50%'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <el-form ref="formRef" :model="form" label-width="80px" :label-position="getIsMobile?'top':'right'" :rules="rules">
      <el-form-item label="型号" prop="ArticleTitle">
        <el-input v-model="form.ArticleTitle" placeholder="请输入型号"></el-input>
      </el-form-item>
      <el-form-item label="品牌" prop="ArticleSource">
        <el-input v-model="form.ArticleSource" placeholder="请输入品牌"></el-input>
      </el-form-item>
      <el-form-item label="价格" prop="renshu">
        <el-input v-model="form.renshu" placeholder="请输入价格"></el-input>
      </el-form-item>
      <el-form-item label="价格来源" prop="address">
        <el-input v-model="form.address" placeholder="请输入价格来源"></el-input>
      </el-form-item>
      <el-form-item label="是否含税" prop="shui">
        <el-radio-group v-model="form.shui">
          <el-radio :label="1">含税</el-radio>
          <el-radio :label="0">未税</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleReset" style="margin-right: 5px">重 置</el-button>
      <el-popconfirm
        title="确定要添加这个型号吗？"
        @confirm="handleSubmit"
      >
        <el-button slot="reference" type="primary">确 定</el-button>
      </el-popconfirm>
    </div>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, ref } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
import request from '@/utils/request'

export default defineComponent({
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(props, { emit }) {
    const formRef = ref(null)
    const { getIsMobile } = useRootSetting()
    const rules = {
      ArticleTitle: [
        { required: true, message: '型号不能为空', trigger: 'blur' }
      ],
      ArticleSource: [
        { required: true, message: '品牌不能为空', trigger: 'blur' }
      ],
      renshu: [
        { required: true, message: '价格不能为空', trigger: 'blur' }
      ],
      address: [
        { required: true, message: '价格来源不能为空', trigger: 'blur' }
      ],
      shui: [
        { required: true, message: '是否含税不能为空', trigger: 'change' }
      ]
    }

    const defaultForm = () => ({
      ArticleTitle: '',
      ArticleSource: '',
      renshu: '',
      address: '',
      shui: ''
    })
    const form = reactive(defaultForm())

    const handleClose = () => {
      emit('close')
    }

    const handleReset = () => Object.assign(form, defaultForm())

    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          request({
            url: 'add_customer.yy',
            method: 'post',
            data: form
          }).then(res => {
             if(res.code == 200) {
               emit('submit',res)
             }
          })
        }
      })
    }

    return {
      getIsMobile,
      formRef,
      form,
      rules,
      handleSubmit,
      handleClose,
      handleReset
    }
  }
})
</script>
